module.exports = __webpack_public_path__ + "img/lol.d97ebb74.svg";